import React, { Fragment } from 'react';

import { Button, Modal, Header, Grid } from 'semantic-ui-react';
import _ from 'lodash';
import ReactTable from 'react-table';

import { TaxGroupSetupFieldEnum as Fields } from 'Common/FieldEnum';

import { Filter, Main } from 'Containers';
import TaxGroupSetupForm from './TaxGroupSetupForm';

import { caseInsensitiveFilter } from 'Common/GridHelper';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { DirtyWrapper } from 'Components';
import { HeaderLeftAlign } from 'Common/Constants/table';

const TaxGroupSetupComponent = props => {
  const {
    open,
    dimmer,
    size,
    rowData,
    isValid,
    showDeleteModal,
    taxGroupSetupData,
    sortById,
    addTaxGroupSetup,
    editTaxGroupSetup,
    deleteTaxGroupSetup,
    handleDialog,
    handleSubmit,
    setIsValid,
    close,
    filtered,
    clearFilters,
    loading,
    onFilteredChange,
    isReadOnly,
  } = props;

  const menuOptions = [
    {
      icon: 'pencil',
      text: 'Edit',
      handler: editTaxGroupSetup,
    },
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: deleteTaxGroupSetup,
      disabledWhen: x => isReadOnly || x.Status,
    },
  ];

  const columns = [
    {
      Header: 'Id',
      accessor: Fields.Id,
      show: false,
    },
    {
      Header: 'Reference Id',
      accessor: Fields.ReferenceId,
      maxWidth: 200,
      filterable: true,
      show: false,
    },
    {
      Header: () => <span className="ml-5">Description</span>,
      accessor: Fields.Description,
      filterable: true,
      resizable: false,
      ...HeaderLeftAlign,
    },
    {
      Header: '',
      id: 'menu',
      width: 120,
      sortable: false,
      resizable: false,
      style: { textAlign: 'center' },
      Cell: gridProps => {
        return GridContextMenu({ gridProps, options: menuOptions });
      },
    },
  ];

  return (
    <Fragment>
      <Filter title={`Tax Group Setup`}>
        <Grid>
          <Grid.Row>
            <Grid.Column floated={'right'} textAlign={'right'}>
              <Button content={`Add Tax Group`} onClick={addTaxGroupSetup} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Filter>
      <Main>
        <Button
          className={'clear-filters-button'}
          content="Clear Filters"
          onClick={clearFilters}
        />
        <ReactTable
          data={_.sortBy(taxGroupSetupData, [
            sortById ? Fields.ReferenceId : Fields.Description,
          ])}
          className={'-striped -highlight grid--fixed-row-height'}
          defaultFilterMethod={caseInsensitiveFilter}
          columns={columns}
          minRows={0}
          pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
          defaultPageSize={10}
          noDataText="No rows found"
          loading={loading}
          filtered={filtered}
          onFilteredChange={filtered => onFilteredChange(filtered)}
        />

        <DirtyWrapper closeModalYesCallback={close} isReadOnly={isReadOnly}>
          {showDirtyConfirm => (
            <Modal
              dimmer={dimmer}
              size={size}
              open={open}
              onClose={showDirtyConfirm}
              closeIcon
              closeOnRootNodeClick={false}
            >
              <Header
                content={
                  rowData.Id === 0
                    ? `Add Tax Group`
                    : `Edit ${rowData.Description}`
                }
                icon="signup"
              />
              <Modal.Content className="p-t-0">
                <Modal.Description>
                  <TaxGroupSetupForm
                    setIsValid={setIsValid}
                    ref={instance => {
                      this.form = instance;
                    }}
                    onSubmit={handleSubmit}
                    initialValues={{
                      [Fields.Id]: rowData.Id,
                      [Fields.ReferenceId]: rowData.RefNum,
                      [Fields.Description]: rowData.Description,
                      [Fields.State]: rowData.State,
                      [Fields.County]: rowData.County,
                      [Fields.Local]: rowData.Local,
                    }}
                  />
                </Modal.Description>
              </Modal.Content>
              <Modal.Actions>
                <Button
                  inverted
                  color="orange"
                  size="big"
                  loading={loading}
                  content="Save"
                  onClick={() => {
                    this.form.submit();
                  }}
                  disabled={!isValid ? true : loading}
                />
              </Modal.Actions>
            </Modal>
          )}
        </DirtyWrapper>
        <YesNoDialog
          showDialog={showDeleteModal}
          title={`Delete Tax Group`}
          question={` Are you sure you want to delete this Tax Group: ${
            rowData.Description
          }?`}
          yesCallback={() => {
            handleDialog(true);
          }}
          noCallback={() => {
            handleDialog(false);
          }}
        />
      </Main>
    </Fragment>
  );
};

export default TaxGroupSetupComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/taxgroupsetup/components/TaxGroupSetupComponent.js